/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent } from '../modal-monitoraggi-sopralluoghi/modal-monitoraggi-sopralluoghi.component';
import { MonitoraggiSopralluoghi } from 'src/app/_models/domain/monitoraggi-sopralluoghi';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-toolkit-opera-tab-monitoraggi-sopralluoghi',
    templateUrl: './tab-monitoraggi-sopralluoghi.component.html',
})
export class ToolkitGestioneOperaTabMonitoraggiSopralluoghiComponent implements OnInit{


    @Input() canEdit: boolean;
    @Input() items: MonitoraggiSopralluoghi[] = [];
    @Input() datalist: DatalistAnagrafica;
    @Input() formGroup: FormGroup;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.operaService.monitoraggiSopralluoghiByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: MonitoraggiSopralluoghi[]) => {
            this.items = list;
        });   
    }
    public viewItem(monitoraggiSopralluoghi: MonitoraggiSopralluoghi) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.formGroup = this.formGroup;
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = monitoraggiSopralluoghi;
        modal.componentInstance.canEdit = false;
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent, { size: 'xl' });
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.formGroup = this.formGroup;
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;

        modal.result.then(payload => {
            if (payload) {
                this.operaService.insertMonitoraggiSopralluoghi(payload).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.monitoraggiSopralluoghiByIdOpera(this.operaService.operaSession.idOpera)
                        .subscribe((list: MonitoraggiSopralluoghi[]) => {
                            this.items = list;
                        });
                });
            }
        }).catch(e => {});
    }


    public editItem(monitoraggiSopralluoghi: MonitoraggiSopralluoghi) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalMonitoraggiSopralluoghiComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.formGroup = this.formGroup;
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = monitoraggiSopralluoghi;
        modal.componentInstance.canEdit = true;
        modal.result.then(payload => {
            if (payload) {
                this.operaService.insertMonitoraggiSopralluoghi(payload).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.monitoraggiSopralluoghiByIdOpera(this.operaService.operaSession.idOpera)
                        .subscribe((list: MonitoraggiSopralluoghi[]) => {
                            this.items = list;
                        });
                });
            }
        }).catch(e => {});

    }


    public deleteItem(idMonitoraggiSopralluoghi: number) {
        this.operaService.deleteMonitoraggiSopralluoghi(idMonitoraggiSopralluoghi).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.operaService.monitoraggiSopralluoghiByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: MonitoraggiSopralluoghi[]) => {
                    this.items = list;
                });
            }
        });
    }

   

    openMonitoraggioScheda(link?: string) {
        if (!link) {
            return;
        }
        if (/^https?:\/\//i.test(link)) {
            window.open(link, '_blank', 'noopener');
            return;
        }
    }

    getRilevatoreDisplay(item: MonitoraggiSopralluoghi): string {
        const id = item.idRilevatore?.idRilevatore;

        if (id === 1) {
            // se id 1 (ENTE), mettiamo enterilevatore
            return item.enterilevatore ?? '';

        }

        if (id === 2) {
            // se id 2 (SOGGETTO INCARICATO DA ENTE) mettiamo semplicemente "SOGGETTO INCARICATO DA ENTE"
            return item.idRilevatore?.descrizione ?? '';
        }

        // default: se servisse, puoi decidere cosa mostrare
        return item.idRilevatore?.descrizione ?? '';
    }


}
